var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 27 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.525,
    y1: -0.311,
    x2: -0.404,
    y2: 1.317,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4a849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3b221"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-sms",
    "data-name": "Icon awesome-sms",
    className: "cls-1",
    d: "M13.5,2.25C6.043,2.25,0,7.238,0,13.393a9.965,9.965,0,0,0,3.006,7,13.67,13.67,0,0,1-2.89,5.132.431.431,0,0,0-.079.466.413.413,0,0,0,.385.257A11.953,11.953,0,0,0,7.836,23.5,15.86,15.86,0,0,0,13.5,24.536c7.457,0,13.5-4.987,13.5-11.143S20.957,2.25,13.5,2.25ZM6.761,16.821H6.117a.427.427,0,0,1-.422-.429v-.857a.427.427,0,0,1,.422-.429h.649c.316,0,.548-.187.548-.354a.285.285,0,0,0-.111-.2L6.049,13.543a1.993,1.993,0,0,1-.7-1.505A2.158,2.158,0,0,1,7.583,9.97h.643a.427.427,0,0,1,.422.429v.857a.427.427,0,0,1-.422.429H7.578c-.316,0-.548.188-.548.354a.285.285,0,0,0,.111.2L8.3,13.248A1.993,1.993,0,0,1,9,14.754,2.155,2.155,0,0,1,6.761,16.821Zm10.114-.429a.427.427,0,0,1-.422.429h-.844a.427.427,0,0,1-.422-.429V12.739L13.88,15.729a.418.418,0,0,1-.754,0l-1.313-2.989v3.654a.427.427,0,0,1-.422.429h-.844a.427.427,0,0,1-.422-.429V10.821a.853.853,0,0,1,.844-.857h.844a.838.838,0,0,1,.754.471l.933,1.9.933-1.9a.844.844,0,0,1,.754-.471h.844a.853.853,0,0,1,.844.857Zm2.547.429h-.649a.427.427,0,0,1-.422-.429v-.857a.427.427,0,0,1,.422-.429h.649c.316,0,.548-.187.548-.354a.285.285,0,0,0-.111-.2L18.7,13.543a1.993,1.993,0,0,1-.7-1.505A2.158,2.158,0,0,1,20.239,9.97h.643a.427.427,0,0,1,.422.429v.857a.427.427,0,0,1-.422.429h-.649c-.316,0-.548.188-.548.354a.285.285,0,0,0,.111.2l1.155,1.007a1.993,1.993,0,0,1,.7,1.505A2.15,2.15,0,0,1,19.422,16.821Z",
    transform: "translate(0 -2.25)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.c2ac535238f3b44fa6bfbeb98cc3d044.svg";
export { ForwardRef as ReactComponent };